(() => {
  function boot() {
    document.querySelectorAll('[data-casame-image-warmup]').forEach(section => {
      if (section.dataset.imageWarmupMounted) return;
      section.dataset.imageWarmupMounted = 'true';
      const images = [...section.querySelectorAll('img')];
      function updateSizes() {
        images.forEach(image => {
          if (image.clientWidth > 0) image.sizes = `${Math.ceil(image.clientWidth)}px`;
        });
      }
      function warm() {
        updateSizes();
        images.forEach(image => {
          image.fetchPriority = 'low';
          image.loading = 'eager';
        });
        if (typeof ResizeObserver !== 'undefined') {
          const resize = new ResizeObserver(updateSizes);
          resize.observe(section);
        }
      }
      if (typeof IntersectionObserver === 'undefined') return;
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          warm();
          observer.unobserve(section);
        }
      }, {rootMargin: '1600px 0px'});
      observer.observe(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
